import { Link } from "react-router-dom";

import { SEO } from "@/components/SEO";

export function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you were looking for couldn't be found."
        path="/404"
      />

      <section
        className="relative overflow-hidden texture-dark"
        style={{ backgroundColor: "#0a0a0a", color: "#fff", minHeight: "70vh" }}
      >
        <div className="container-page py-20 sm:py-28 lg:py-36 flex flex-col items-center text-center">

          <span
            className="font-display block"
            style={{
              fontSize: "clamp(6rem, 18vw, 14rem)",
              lineHeight: 0.85,
              color: "rgba(255,255,255,0.05)",
              letterSpacing: "-0.02em",
            }}
          >
            404
          </span>

          <div
            aria-hidden="true"
            className="my-6"
            style={{ width: 48, height: 4, backgroundColor: "#d71920" }}
          />

          <h1
            className="font-display uppercase"
            style={{
              fontSize: "clamp(2rem, 5vw, 3.5rem)",
              lineHeight: 1.05,
            }}
          >
            Page Not Found
          </h1>

          <p
            className="mt-4 text-lg mx-auto"
            style={{ color: "rgba(255,255,255,0.6)", maxWidth: "36ch" }}
          >
            The page you were looking for doesn&apos;t exist or has been moved.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/" className="btn-primary">
              Back to Home
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Us
            </Link>
          </div>

          <nav className="mt-14" aria-label="Quick links">
            <p
              className="text-xs uppercase tracking-widest mb-4"
              style={{ color: "rgba(255,255,255,0.3)" }}
            >
              Or try one of these
            </p>
            <ul className="flex flex-wrap justify-center gap-3 list-none p-0">
              <li>
                <Link
                  to="/about"
                  className="text-sm uppercase tracking-wide no-underline"
                  style={{ color: "rgba(255,255,255,0.5)" }}
                >
                  About
                </Link>
              </li>
              <li aria-hidden="true" style={{ color: "rgba(255,255,255,0.15)" }}>&middot;</li>
              <li>
                <Link
                  to="/training"
                  className="text-sm uppercase tracking-wide no-underline"
                  style={{ color: "rgba(255,255,255,0.5)" }}
                >
                  Training
                </Link>
              </li>
              <li aria-hidden="true" style={{ color: "rgba(255,255,255,0.15)" }}>&middot;</li>
              <li>
                <Link
                  to="/join"
                  className="text-sm uppercase tracking-wide no-underline"
                  style={{ color: "rgba(255,255,255,0.5)" }}
                >
                  Join Our Club
                </Link>
              </li>
              <li aria-hidden="true" style={{ color: "rgba(255,255,255,0.15)" }}>&middot;</li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm uppercase tracking-wide no-underline"
                  style={{ color: "rgba(255,255,255,0.5)" }}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
    </>
  );
}
